class LocalStorageService {
  // this method can get data from local storage by any key
  get(localStorageKey: any) {
    const localStorageValue = JSON.parse(
      localStorage.getItem(localStorageKey) || "{}"
    );
    return localStorageValue;
  }
  // this method can set  any value  in local storage by any key
  set(localStorageKey: any, localStorageValue: any) {
    localStorage.setItem(localStorageKey, JSON.stringify(localStorageValue));
  }
  // this method can remove data  in local storage by any key
  remove(localStorageKey: any) {
    localStorage.removeItem(localStorageKey);
  }
}
export default new LocalStorageService();
